module.exports = __webpack_public_path__ + "img/clock_active.6d12fa3b.svg";